/* @flow */

import React, { Component } from 'react'
import S from './Header16.styled'
import { validation } from './Header16.consts'
import ActionGetter from './Actions'
import Mapper from '@website/common/components/Mapper'
import If from '@website/common/components/Conditional'
import { getDate, getDateDistance } from '@website/common/utils'
import { MobileDetectContext, DispatchContext } from '@contexts'
import EditableContent from '@website/common/components/EditableContent'

class CountDownDate extends Component<> {
  state = {
    formatedDates: getDate(this.props.date)
  }
  dateChanger = null

  componentDidMount() {
    this.countDownDate()
  }

  componentWillUnmount() {
    if (this.dateChanger) {
      clearInterval(this.dateChanger)
    }
  }
  componentDidUpdate(prevProps) {
    if (!this.dateChanger && prevProps.date !== this.props.date) {
      this.countDownDate()
    }
  }

  countDownDate = () => {
    this.dateChanger = setInterval(() => {
      const { date } = this.props
      const distance = getDateDistance(date)
      if (distance < 0) {
        clearInterval(this.dateChanger)
        this.dateChanger = null
      }
      this.setState({ formatedDates: getDate(date) })
    }, 1000)
  }

  render() {
    const { dateLabels, openDatePicker } = this.props
    const { formatedDates } = this.state
    const Actions = ActionGetter(this.context)

    return (
      <MobileDetectContext.Consumer>
        {isMobile => (
          <div className="date-container">
            <Mapper
              data={Object.keys(formatedDates)}
              render={(formatedDate, idx) => {
                return (
                  <>
                    <S.DateWrap className="formatedDate" key={idx}>
                      <div onClick={openDatePicker}>
                        <S.Time className="WM_GLOBAL_primary-font">
                          {formatedDates[formatedDate]}
                        </S.Time>
                      </div>
                      <EditableContent
                        text={isMobile ? dateLabels[idx][0] : dateLabels[idx]}
                        as={S.Date}
                        maxCount={validation.dateLabelsMaxChar}
                        className="WM_GLOBAL_secondary-font"
                        required={validation.dateLabels.required}
                        onChange={(newDateLabel: string) => {
                          Actions.changeDateLabel(newDateLabel, idx)
                        }}
                        areControlsHidden
                      />
                    </S.DateWrap>
                    <If
                      condition={idx < 3}
                      then={() => <S.TimeDots>:</S.TimeDots>}
                    />
                  </>
                )
              }}
            />
          </div>
        )}
      </MobileDetectContext.Consumer>
    )
  }
}

CountDownDate.contextType = DispatchContext
export default CountDownDate
